import {
  LinkConfig,
  NavigationLinkTargets,
} from '@zipari/shared-ds-util-navigation';

export interface TileGridCard {
  key: string;
  position: number;
  title: string;
  description: string;
  icon: string;
  icon_color?: string;
  icon_size?: string;
  route: string;
  link: LinkConfig;
  target?: NavigationLinkTargets;
  isExternalRoute: boolean;
  useExternalSiteModal: boolean;
}

export interface TileGridArgs {
  tiles: TileGridCard[];
  columns: number;
  externalSiteModalConfig: unknown;
}
